import { useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'

/** TRANSLATION*/
import { useTranslation } from 'react-i18next'

/** API */
import TreatmentCourseApi from 'api/setting/treatment-courses/treatment-course.api'

/** COMPONENT */
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import { Box, Grid, InputAdornment, Typography } from '@mui/material'
import HeaderCard from 'component/CardCustom/HeaderCard'
import TableRowExport from 'component/Pdf/TableRowExport'
import TableCustom from 'component/Table/TableCustom'
import TableRowCommon from 'component/Table/TableRowCommon'
import { notiError } from 'component/notifications/notifications'
import DropdownButton from 'new-components/buttons/dropdown-button'
import MainButton from 'new-components/buttons/main-button'
import SelectInput from 'new-components/inputs/select-input'
import TextInput from 'new-components/inputs/text-input'
import AlertModal from 'new-components/modal/alert-modal'
import SnackbarComponent from 'new-components/snackbar/snackbar-component'
import { routeName } from 'routes/routes-name'
import { numberFormat } from 'utils/app.utils'
import { dateTimeToView } from 'utils/date.utils'
import { exportCourseToExcel } from './exportCourseToExcel'

export default function TreatmentCourse() {
  const { t } = useTranslation()
  const history = useHistory()
  const componentRef = useRef<any>(null)
  const [treatmentCourses, setTrementCourses] = useState([])
  const [exportData, setExportData] = useState([])

  /** PAGINATION  */
  const [page, setPage] = useState(1)
  const [pageLimit, setPageLimit] = useState(10)
  const [rowCount, setRowCount] = useState(0)
  const [sortBy, setSortBy] = useState('createAt')
  const [sortType, setSortType] = useState('ASC')
  const [search, setSearch] = useState('')
  const [status, setStatus] = useState('ALL')

  const [isOpenAlertModal, setIsOpenAlertModal] = useState(false)
  const [statusAlertModal, setStatusAlertModal] = useState('')
  const [id, setId] = useState<number>(0)
  const [name, setName] = useState('')
  const [nameEn, setNameEn] = useState('')
  const [isOpenSnack, setIsOpenSnack] = useState(false)
  const [typeSnack, setTypeSnack] = useState<any>("success")
  const [labelSnack, setLabelSnack] = useState('')

  const loadData = async () => {
    try {
      let condition = {}
      condition = {
        page: page,
        pageLimit: pageLimit,
        search: search,
        sortBy: sortBy,
        sortType: sortType,
        status: status === 'ALL' ? '' : status
      }
      const resp = await TreatmentCourseApi.findAll(condition)
      const respExport = await TreatmentCourseApi.findAll({ ...condition, export: 1 })
      if (resp.status === 200) {
        setRowCount(resp.headers['x-total'])
        setTrementCourses(resp.data)
        setExportData(respExport.data)
      } else {
        setTrementCourses([])
        setExportData([])
      }
    } catch (error) {
      notiError('ERROR')
    }
  }

  useEffect(() => {
    loadData()
  }, [page, pageLimit, sortBy, sortType])


  const onCreact = () => {
    history.push(routeName.treatmentCourse + '/create')
  }

  const onActive = () => {
    if (id) {
      TreatmentCourseApi.updateStatus(id, statusAlertModal).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('TREATMENT_COURSE.MESSAGE.SUCCESS.UPDATE_STATUS'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('TREATMENT_COURSE.MESSAGE.ERROR'))
        }
      })
    }
  }
  const onDelete = () => {
    if (id) {
      TreatmentCourseApi.remove(id).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('TREATMENT_COURSE.MESSAGE.SUCCESS.DELETE'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('TREATMENT_COURSE.MESSAGE.ERROR'))
        }
      })
    }
  }

  const onEdit = (objData: any) => {

    history.push(routeName.treatmentCourse + '/update', objData)
  }

  const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
    setSortType(sortTypeVal)
    setSortBy(sortByVal)
  }

  const handleChangePage = (val: number) => {
    setPage(val)
  }

  const handleChangeRowsPerPage = (limit: number) => {
    setPageLimit(limit)
  }
  const handleChangeStatus = (statusVal: string) => {
    setStatus(statusVal)
  }
  const headCells = [
    {
      id: 'no',
      disablePadding: false,
      label: t('TABLE.NO'),
      width: '80px'
    },
    {
      id: 'treatmentCourseTypeName',
      disablePadding: false,
      label: t('TREATMENT_COURSE.TABLE.CELL.TREATMENT_COURSE_NAME_TYPE'),
      width: '200px'
    },

    {
      id: 'treatmentCourseName',
      disablePadding: false,
      label: t('TREATMENT_COURSE.TABLE.CELL.TREATMENT_COURSE_NAME'),
    },
    {
      id: 'productQty',
      disablePadding: false,
      label: t('TREATMENT_COURSE.TABLE.CELL.QTY'),
      align: 'center',
      width: '150px'
    },
    {
      id: 'totalPrice',
      disablePadding: false,
      label: t('TREATMENT_COURSE.TABLE.CELL.PRICE_BATH'),
      align: 'right',
      width: '200px'
    },
    {
      id: 'status',
      disablePadding: false,
      label: t('TREATMENT_COURSE.TABLE.CELL.STATUS'),
      width: '200px'
    },
    {
      id: 'updatedBy',
      disablePadding: false,
      label: t('TREATMENT_COURSE.TABLE.CELL.UPDATED_BY'),
      width: '220px'
    },

    {
      id: 'action',
      disablePadding: false,
      label: 'Action',
      width: '80px'
    }
  ]

  const renderData = (objData: any, no: number, valueExportData: boolean) => {
    const num = valueExportData === true ? no + 1 : page * pageLimit - pageLimit + no + 1
    const { treatmentCourseId, treatmentCourseName, treatmentCourseTypeName, totalQty, totalPrice, updatedBy, status: treatmentCourseStatus, updatedAt } = objData
    const statusBtnActive = treatmentCourseStatus === 'ACTIVE' ? true : false
    const statusBtnInActive = treatmentCourseStatus === 'INACTIVE' ? true : false
    const objRenderData = {
      key: treatmentCourseId,
      id: treatmentCourseId,
      obj: objData,
      columns: [
        { option: 'TEXT', align: 'center', label: num },
        { option: 'TEXT', align: 'left', label: treatmentCourseTypeName || "-" },

        { option: 'TEXT', align: 'left', label: treatmentCourseName || "-" },
        { option: 'TEXT', align: 'center', label: totalQty },
        { option: 'TEXT', align: 'right', label: numberFormat(totalPrice) },
        { option: 'STATUS', align: 'center', label: treatmentCourseStatus },
        { option: 'UPDATE_BY', align: 'center', label: { updatedBy: updatedBy, updatedAt: updatedAt } },
        {
          option: 'ACTION',
          align: 'center',
          label: 'action',
          values: [
            { option: 'STATUS_ACTIVE', label: t(`STATUS.ACTIVE`), disabled: statusBtnActive },
            { option: 'STATUS_INACTIVE', label: t(`STATUS.INACTIVE`), disabled: statusBtnInActive },
            { option: 'DIVIDER', label: '', disabled: false },
            { option: 'EDIT', label: t(`BUTTON.EDIT`), disabled: false },
            { option: 'DELETE', label: t(`BUTTON.DELETE`), disabled: false }
          ]
        }
      ]
    }
    return (
      <>
        {valueExportData === true && <TableRowExport {...objRenderData} /> ||
          <TableRowCommon
            {...objRenderData}
            onactive={() => handleSubmitModal(Number(objRenderData.id), 'ACTIVE', objRenderData.obj)}
            oninactive={() => handleSubmitModal(Number(objRenderData.id), 'INACTIVE', objRenderData.obj)}
            onedit={() => onEdit(objRenderData.obj)}
            ondelete={() => handleSubmitModal(Number(objRenderData.id), 'DELETE', objRenderData.obj)}
          />
        }
      </>
    )
  }

  const handleSubmitModal = (id: number, status: string, obj?: any) => {
    setStatusAlertModal(status)
    setId(id)
    setIsOpenAlertModal(true)
    setName(obj.treatmentCourseName)
    setNameEn(obj.treatmentCourseNameEn)
  }

  const filter = [
    { label: `${t('INPUT.SEARCH')}: ${search || '-'}` },
    { label: `${t('STATUS.LABEL')}: ${t(`STATUS.${status}`)}` }
  ]


  return (
    <Box>
      <AlertModal
        isOpen={isOpenAlertModal}
        title={t(`TREATMENT_COURSE.ALERT.${statusAlertModal === 'DELETE' ? 'TITLE_DELETE' : 'TITLE_ACTIVE'}`)}
        message={t(`TREATMENT_COURSE.ALERT.${statusAlertModal === 'DELETE' ? 'CONFIRM_DELETE_' : 'CONFIRM_STATUS'}`, { treatmentCourseName: name, treatmentCourseNameEn: nameEn && `(${nameEn})`, status: t(`TREATMENT_COURSE.ALERT.${statusAlertModal}`) })}
        type={statusAlertModal === 'DELETE' ? 'error' : 'warning'}
        handleClose={() => setIsOpenAlertModal(false)}
        onCancel={{ onClick: () => setIsOpenAlertModal(false), title: t('BUTTON.CANCEL') }}
        onSubmit={{ onClick: statusAlertModal === 'DELETE' ? onDelete : onActive, title: t('BUTTON.SUBMIT') }}
      />
      <SnackbarComponent
        onOpen={isOpenSnack}
        onClose={() => setIsOpenSnack(false)}
        label={labelSnack}
        type={typeSnack}
        transform={`translateX(calc(100vw - 100% - 32px)) translateY(calc(-100vh + 100% + ${window.innerHeight - 50}px))`}
        autoHideTime={3000}
      />
      <HeaderCard text={t('TREATMENT_COURSE.TITLE')} />
      <Box paddingX="24px" paddingTop="16px">
        <Grid container spacing="16px">
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <TextInput
              label={t('TREATMENT_COURSE.SEARCH')}
              value={search}
              onChange={(event) => {
                setSearch(event.target.value)
              }}
              fullWidth
              inputProps={{
                endAdornment: (
                  <InputAdornment position="end" >
                    {!search ? <FontAwesomeIcon icon={faSearch} style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 15 }} /> :
                      <FontAwesomeIcon
                        icon={faTimes}
                        onClick={() => {
                          setSearch('');
                        }}
                        style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 17, cursor: 'pointer' }} />}
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <SelectInput
              onChange={(event) => {
                const value = event.target.value
                if (value) {
                  handleChangeStatus(value)
                }
              }}
              options={[
                { value: 'ALL', name: t('STATUS.ALL') },
                { value: 'ACTIVE', name: t('STATUS.ACTIVE') },
                { value: 'INACTIVE', name: t('STATUS.INACTIVE') }
              ]}
              label={t('STATUS.LABEL')}
              value={status}
              width="100%"
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} xl={8}>
            <Box display={'flex'} justifyContent={'space-between'}>
              <MainButton
                title={t('INPUT.SEARCH')}
                type='primary'
                variant='contained'
                style={{ width: '120px' }}
                onClick={() => {
                  setPage(1)
                  loadData()
                }} />

              <Box display="flex" flexDirection="row" alignItems="center" gap="16px">
                <DropdownButton title='พิมพ์เอกสาร' onChange={(e) => {
                  if (e === 'Excel') {
                    const report: any = {
                      title: t('TREATMENT_COURSE.TITLE'),
                      statusFilter: filter[1].label,
                      rows: exportData.map((item: any) => ({
                        treatmentCourseTypeName: item?.treatmentCourseTypeName || '-',
                        treatmentCourseName: item?.treatmentCourseName || '-',
                        totalQty: Number(item?.totalQty),
                        totalPrice: item?.totalPrice,
                        status: t(`STATUS.${item?.status}`),
                        updatedBy: item?.updatedBy || '-',
                        updatedAt: dateTimeToView(item?.updatedAt) || '-'
                      })),
                      t: t
                    }
                    exportCourseToExcel(report)
                  } else if (e === 'PDF') {
                    const style = document.createElement("style");
                    style.innerHTML = `
                      @media print {
                        @page { size: portrait }
                      }
                    `;
                    document.head.appendChild(style);
                    window.print();
                    document.head.removeChild(style);

                  }
                }} options={[{ value: 'Excel', name: ' Excel' }, { value: 'PDF', name: ' PDF' }]} />
                <MainButton title={t('TREATMENT_COURSE.BUTTON.ADD')} type='primary' variant='contained' onClick={() => onCreact()} startIcon={<AddCircleIcon />} />
              </Box>
            </Box>
          </Grid>
        </Grid>

        <Box paddingTop="24px">
          <TableCustom
            page={page}
            pageLimit={pageLimit}
            sortType={sortType}
            sortBy={sortBy}
            onSort={onRequestSort}
            setPageLimit={handleChangeRowsPerPage}
            setPage={handleChangePage}
            rowCount={rowCount}
            headCells={headCells}
            rowsData={treatmentCourses.map((val, i) => {
              return renderData(val, i, false)
            })}
            tableFixedWidth
            tableMinWidth={1440}
          />

          <Box
            id="print-table-container"
            ref={componentRef}
          >
            <Typography fontSize="14px" fontWeight={400}>{t('TREATMENT_COURSE.TITLE')}</Typography>
            <Box display='flex' flexDirection="row" alignItems="center" gap="16px">
              <Typography fontSize="10px" fontWeight={400}>{t('STATUS.LABEL')}: {status === 'ALL' ? t('STATUS.ALL') : status === 'ACTIVE' ? t('STATUS.ACTIVE') : t('STATUS.INACTIVE')}</Typography>
            </Box>
            <table style={{ width: '100%', border: '1px solid black', borderCollapse: 'collapse', marginTop: '16px' }}>
              <thead>
                <tr style={{ textAlign: 'center', fontSize: '9.5px', fontWeight: 700 }}>
                  <th style={{ borderBottom: '1px solid black' }}>{t('#')}</th>
                  <th style={{ borderBottom: '1px solid black', textAlign: 'left' }}>{t('TREATMENT_COURSE.TABLE.CELL.TREATMENT_COURSE_NAME_TYPE')}</th>
                  <th style={{ borderBottom: '1px solid black', textAlign: 'left' }}>{t('TREATMENT_COURSE.TABLE.CELL.TREATMENT_COURSE_NAME')}</th>
                  <th style={{ borderBottom: '1px solid black', textAlign: 'center' }}>{t('TREATMENT_COURSE.TABLE.CELL.QTY')}</th>
                  <th style={{ borderBottom: '1px solid black', textAlign: 'center' }}>{t('TREATMENT_COURSE.TABLE.CELL.PRICE_BATH')}</th>
                  <th style={{ borderBottom: '1px solid black' }}>{t('TREATMENT_COURSE.TABLE.CELL.STATUS')}</th>
                  <th style={{ borderBottom: '1px solid black' }}>{t('TREATMENT_COURSE.TABLE.CELL.UPDATED_BY')}</th>
                </tr>
              </thead>
              <tbody>
                {exportData?.length === 0 &&
                  <tr>
                    <td colSpan={7} style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'center', width: '100%' }}>{t('NOT_FOUND')}</td>
                  </tr>
                }
                {exportData.map((data: any, index: number) => (
                  <tr key={index}>
                    <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'center', width: '50px' }}>{index + 1}</td>
                    <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'left', verticalAlign: 'center' }}>{data?.treatmentCourseTypeName || '-'}</td>
                    <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'left', verticalAlign: 'center' }}>{data?.treatmentCourseName || '-'}</td>
                    <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'center' }}>{data?.totalQty || '-'}</td>
                    <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'center' }}>{numberFormat(data?.totalPrice) || '-'}</td>
                    <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'center', width: '100px' }}>{t(`STATUS.${data?.status}`) || '-'}</td>
                    <td style={{ fontSize: '9.5px', fontWeight: 500, textAlign: 'center', verticalAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                      <span>{data?.updatedBy || '-'}</span>
                      <span>{dateTimeToView(data?.updatedAt) || '-'}</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
